import React, { useState, useEffect } from 'react';
import { api } from '../../../config/api';


const SentenceModal = ({ isOpen, onClose, word }) => {

    const [sentence, setSentence] = useState(null)
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    
    useEffect(() => {
      const fetchSentence = async () => {
        if (!isOpen) return;
        getSentence();
      };
    
      fetchSentence();
    }, [isOpen, word]);

  const getSentence = async (sentence) => {
    try {
        setLoading(true);
        setError(null);
        const response = await api.getSentence(word.word_id);
        setSentence(response);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
  }
    
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md relative">
        <button
          type="button"
          onClick={onClose}
          className="absolute top-4 right-4 text-neutral-400 hover:text-neutral-600 transition-colors"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
        
        <div className="p-4">
          <h2 className="text-sm font-semibold mb-4">Zdanie pomocnicze</h2>
          {loading ? (
            <div className="flex items-center justify-center py-8">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-500"></div>
            </div>
          ) : error ? (
            <div className="text-red-500 text-center py-4">
              {error}
            </div>
          ) : sentence ? (
            <div>
              <div className="space-y-4">
                <p className="text-neutral-700">
                  {sentence.zdanie.split(/<word>|<\/word>/).map((part, index) => (
                    index % 2 === 0 ? part : <span key={index} className="font-semibold text-primary-600">{part}</span>
                  ))}
                </p>
                <p className="text-sm text-neutral-500 mt-2">
                  {sentence.tłumaczenie.split(/<word>|<\/word>/).map((part, index) => (
                    index % 2 === 0 ? part : <span key={index} className="font-semibold text-primary-600">{part}</span>
                  ))}
                </p>
              </div>
              <div className="mt-4 flex justify-end">
                <button
                  onClick={() => getSentence()} 
                  className="px-3 py-1 text-xs font-medium text-white bg-primary-600 rounded-md hover:bg-primary-700 transition-colors"
                >
                  Inne zdanie
                </button>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default SentenceModal;
